// Contact Form Handler for CRC Portal

class ContactFormHandler {
  constructor() {
    this.form = document.getElementById('contactForm');
    this.submitButton = null;
    this.init();
  }

  init() {
    if (this.form) {
      this.submitButton = this.form.querySelector('button[type="submit"]');
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
      this.setupValidation();
    }
  }

  setupValidation() {
    const inputs = this.form.querySelectorAll('input[required], select[required], textarea[required]');
    
    inputs.forEach(input => {
      input.addEventListener('blur', this.validateField.bind(this));
      input.addEventListener('input', this.clearErrors.bind(this));
    });
  }

  validateField(event) {
    const field = event.target;
    const value = field.value.trim();
    
    // Remove existing error styling
    this.clearFieldError(field);
    
    // Validate based on field type
    let isValid = true;
    let errorMessage = '';
    
    if (field.hasAttribute('required') && !value) {
      isValid = false;
      errorMessage = '此字段为必填项';
    } else if (field.type === 'email' && value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        isValid = false;
        errorMessage = '请输入有效的邮箱地址';
      }
    } else if (field.type === 'tel' && value) {
      const phoneRegex = /^[\d\s\-\+\(\)]+$/;
      if (!phoneRegex.test(value)) {
        isValid = false;
        errorMessage = '请输入有效的电话号码';
      }
    }
    
    if (!isValid) {
      this.showFieldError(field, errorMessage);
    }
    
    return isValid;
  }

  showFieldError(field, message) {
    field.classList.add('is-invalid');
    
    // Create or update error message
    let errorDiv = field.parentNode.querySelector('.invalid-feedback');
    if (!errorDiv) {
      errorDiv = document.createElement('div');
      errorDiv.className = 'invalid-feedback';
      field.parentNode.appendChild(errorDiv);
    }
    errorDiv.textContent = message;
  }

  clearFieldError(field) {
    field.classList.remove('is-invalid');
    const errorDiv = field.parentNode.querySelector('.invalid-feedback');
    if (errorDiv) {
      errorDiv.remove();
    }
  }

  clearErrors(event) {
    this.clearFieldError(event.target);
  }

  async handleSubmit(event) {
    event.preventDefault();
    
    // Validate all fields
    const inputs = this.form.querySelectorAll('input[required], select[required], textarea[required]');
    let isFormValid = true;
    
    inputs.forEach(input => {
      if (!this.validateField({ target: input })) {
        isFormValid = false;
      }
    });
    
    if (!isFormValid) {
      this.showFormError('请检查并修正表单中的错误');
      return;
    }
    
    // Show loading state
    this.setLoadingState(true);
    
    try {
      // Collect form data
      const formData = this.collectFormData();
      
      // Simulate API call (replace with actual endpoint)
      await this.submitFormData(formData);
      
      // Success - redirect to success page
      window.location.href = 'contact-success.html';
      
    } catch (error) {
      console.error('Form submission error:', error);
      this.showFormError('提交失败，请稍后重试或直接联系我们');
    } finally {
      this.setLoadingState(false);
    }
  }

  collectFormData() {
    const formData = new FormData(this.form);
    const data = {};
    
    for (let [key, value] of formData.entries()) {
      data[key] = value;
    }
    
    // Add timestamp and source
    data.timestamp = new Date().toISOString();
    data.source = 'crc_portal_website';
    data.page = window.location.pathname;
    
    return data;
  }

  async submitFormData(data) {
    // Simulate API call - replace with actual implementation
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // Log data for now (in production, send to your backend)
        console.log('Contact form submission:', data);
        
        // Store in localStorage as backup
        const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
        submissions.push(data);
        localStorage.setItem('contactSubmissions', JSON.stringify(submissions));
        
        // Simulate success
        resolve({ success: true, id: Date.now() });
      }, 1500);
    });
  }

  setLoadingState(isLoading) {
    if (!this.submitButton) return;
    
    if (isLoading) {
      this.submitButton.disabled = true;
      this.submitButton.innerHTML = `
        <span class="loading-spinner me-2"></span>
        提交中...
      `;
    } else {
      this.submitButton.disabled = false;
      this.submitButton.innerHTML = `
        提交咨询 <i class="fe fe-arrow-right ms-3"></i>
      `;
    }
  }

  showFormError(message) {
    // Remove existing error
    const existingError = this.form.querySelector('.form-error-message');
    if (existingError) {
      existingError.remove();
    }
    
    // Create error message
    const errorDiv = document.createElement('div');
    errorDiv.className = 'alert alert-danger form-error-message mt-3';
    errorDiv.innerHTML = `
      <i class="fe fe-alert-circle me-2"></i>
      ${message}
    `;
    
    // Insert before submit button
    const submitRow = this.form.querySelector('.row:last-child');
    submitRow.parentNode.insertBefore(errorDiv, submitRow);
    
    // Auto-remove after 5 seconds
    setTimeout(() => {
      if (errorDiv.parentNode) {
        errorDiv.remove();
      }
    }, 5000);
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ContactFormHandler();
});

// Export for potential use in other scripts
window.ContactFormHandler = ContactFormHandler;